import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-public-portal',
    templateUrl: './public-portal.component.html',
    styleUrls: ['./public-portal.component.scss'],
    standalone: false
})
export class PublicPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
